import { language } from "../types/project/language";
import { project, projectAccess, projectGroup } from "../types/project/project";
import { abstractApiCaller } from "./apiCaller";

class ProjectApi  extends abstractApiCaller {

    private sessionToken: string = '';
    private sessionEmail: string = '';

    constructor(
        sessionToken: string,
        sessionEmail: string,
    ) {
        super();
        this.sessionToken = sessionToken;
        this.sessionEmail = sessionEmail;
    }

    public async getListProjects() {
        const endpoint = 'project/getProjectList';

        const param = {
        };

        this.abortRequest();
        return await this.query<project[]>(endpoint, param, this.sessionToken, this.sessionEmail);

    }

    public async getProjectData (projectId: string) {
        const endpoint = 'project/getProjectData';

        const param = {
            projectId: projectId
        };

        this.abortRequest();
        return await this.query<project>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    public async saveProject (projectId: string, projectData: project, complete: boolean = false) {
        let endpoint = 'project/save/' + projectId;
        if (complete) {
            endpoint = 'project/saveProjectComplete/' + projectId;
        }

        const param = {
            projectData: projectData
        };

        this.abortRequest();
        return await this.query<project>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    public async saveProjectAccess (projectId: string, access: projectAccess[]) {
        const endpoint = 'project/saveAccess/' + projectId;

        const param = {
            access: access
        };

        this.abortRequest();
        return await this.query<project>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    public async saveProjectLanguages (projectId: string, languages: language[]) {
        const endpoint = 'project/saveLanguages/' + projectId;

        const param = {
            languages: languages
        };

        this.abortRequest();
        return await this.query<project>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    public async saveGroupData(projectId: string, groupData: projectGroup) {
        const endpoint = 'project/saveGroup/' + projectId;

        const param = {
            group: groupData
        };

        this.abortRequest();
        
        return await this.query<project>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    public async deleteGroupData(projectId: string, groupId: string) {
        const endpoint = 'project/deleteGroup/' + projectId;

        const param = {
            groupId: groupId
        };

        this.abortRequest();
        
        return await this.query<project>(endpoint, param, this.sessionToken, this.sessionEmail);
    }

    

}

export { ProjectApi };
